import React from "react";
import "./styles.css"
import { ClientResponse, Question, QuestionOption, saveQuestionReview } from "./Question";
import { ParseJson, QuestionTypes, transformDateWithoutTime } from "dynamic-questionarie";
import QuestionnaireReportForm from "./QuestionnaireReportForm";
interface QuestionnaireComponentProps {  
  questionsData: Array<Question>;
  refreshQuestionsData:boolean;
  disableFields:boolean;
  formName:string;
  clientDetails:string;
  showMessageAndHistory:boolean
}
interface QuestionnaireComponentState {
  currentQuestions: Array<Question>;
  formInitialvalues: any;
  reviewValues:any;
}

class QuestionnaireReportComponent extends React.Component<
  QuestionnaireComponentProps,
  QuestionnaireComponentState
> {
  constructor(props: QuestionnaireComponentProps) {
    super(props);
    this.state = {
      currentQuestions: [],
      formInitialvalues: {},
      reviewValues:{}
    };
  }
  componentDidMount() {
    this.setQuestions();
  }
  componentDidUpdate(previousProps: any) {
    if (previousProps.questionsData?.length != this.props?.questionsData?.length) {
      this.setQuestions();
    }
    if(previousProps?.refreshQuestionsData != this.props?.refreshQuestionsData && this.props?.refreshQuestionsData){
      this.setQuestions();
    }
  }

  postsavequestion = (body:saveQuestionReview) => {
    //this.props.postsavequestion(body);
  };
  setQuestions = () => {
    
    //Constructing redux form values by using questionsData
    const initialValues: Record<string, any> = {};
    const reviewValues:Record<string, any>={}
    this.props.questionsData?.forEach((element: Question) => {
      if (element.options.length>0) {
        const s = element.answers?.map((elm: any) => elm.optionId);
        let val = { ["question_" + element.clientQuestionId.toString()]: '' };
        if(s){
          const answers = element.options.filter(m=> m!= null && s &&  s.indexOf(m.value)>-1).map(m=>m.text);
          if(answers){
            val = { ["question_" + element.clientQuestionId.toString()]: answers.toString() };
          }          
        }        
        
        Object.assign(initialValues, val);
      } else if (element.questionType === QuestionTypes.Text ||
         element.questionType === QuestionTypes.TextArea ||
          element.questionType === QuestionTypes.Email || 
          element.questionType===QuestionTypes.PhoneNumber || 

          element.questionType===QuestionTypes.SSN || 
          element.questionType===QuestionTypes.Currency || 
          element.questionType===QuestionTypes.ZipCode || 
          element.questionType===QuestionTypes.Number ||
          element.questionType === QuestionTypes.Percentage
          ) {
        const answerObj = element.answers != null ? element.answers[0] : null;
        const val = {
          ["question_" + element.clientQuestionId.toString()]: answerObj?.answer,
        };
        Object.assign(initialValues, val);
      } else if (element.questionType === QuestionTypes.FileUpload) {
        let answers = element?.answers?.map((item:ClientResponse)=>{
          if(item.answer){
            return ParseJson(item.answer);
          }
          return null;
        });
        answers = answers?.filter(item=> item!= null).map(m=>m.fileName);        
        const val = {
          ["question_" + element.clientQuestionId.toString()]: answers,
        };    
        Object.assign(initialValues, val);   
      }
      else if(QuestionTypes.DatePicker){
        if(element.answers !=null){
          const value=transformDateWithoutTime(element?.answers[0]?.answer)
          const val = {
            ["question_" + element.clientQuestionId.toString()]: value,
          };    
          Object.assign(initialValues, val);   
        } 
        
      }
      else {
        const answerObj = element.answers != null ? element.answers[0] : null;
        const val = {
          ["question_" + element.clientQuestionId.toString()]: answerObj?.optionId,
        };
        
        Object.assign(initialValues, val);
      }
      const review={
        ["questionReview_" + element.clientQuestionId.toString()]: element.reviewNotes,
      }
      Object.assign(reviewValues, review);
    });
    if (this.props?.questionsData?.length > 0) {
      let questionsData = this.props?.questionsData;
      questionsData = questionsData.sort(
        (a, b) => a.questionSequence - b.questionSequence
      );
      let currentQuestions = questionsData?.filter((m) => m.dependent == false);

      //find the dependent questions based on answers      
      Object.keys(initialValues).forEach((key:string)=>{
        if(Array.isArray(initialValues[key])){
          const clientQuestionId = parseInt( key.replace("question_",''));
          const answeredQuestion =  this.props.questionsData.find(m=>m.clientQuestionId == clientQuestionId);
          if(answeredQuestion){
            const options = answeredQuestion.options.filter(
              (ele: QuestionOption) => initialValues[key].indexOf( ele.value) >-1 && ele.goToNextQuestion!= null
            );
            options.forEach(option=>{
              let nextQuestion = this.props.questionsData.find(
                (ele: any) => ele.questionId == option.goToNextQuestion && 
                ele.serialNumber == answeredQuestion.serialNumber
              );
              if (nextQuestion) {
                if (currentQuestions.find((m) => m.questionId == nextQuestion?.questionId && 
                m.serialNumber == answeredQuestion.serialNumber)) {
                  nextQuestion = undefined;
                }
              }
              const answeredQuestionIndex = currentQuestions.findIndex(
                (m) => m.questionId == answeredQuestion?.questionId && m.serialNumber == answeredQuestion.serialNumber
              );
              if (nextQuestion && nextQuestion.denpendentQuestionGroupId) {
                const groupQuestions = this.getDependentGroupQuestions(nextQuestion,true);
                // need to append to the current question
                
                groupQuestions.forEach((question, index) => {
                  currentQuestions.splice(answeredQuestionIndex + 1 + index, 0, question);
                }); 
              }
              if(nextQuestion && !nextQuestion.denpendentQuestionGroupId){
                currentQuestions.splice(answeredQuestionIndex + 1, 0, nextQuestion);
              }
            });            
          }
        }      
      });
      currentQuestions = currentQuestions.sort(
        (a, b) => a.questionSequence - b.questionSequence
      );
      this.setState({
        currentQuestions: currentQuestions,
      });
    }
    
    this.setState((prevstate) => ({
      ...prevstate,
      formInitialvalues: initialValues,
      reviewValues:reviewValues
    }));
  };  
  getDependentGroupQuestions = (question: Question, includeSerialNumbers=false): Array<Question> => {
    if (question && question.denpendentQuestionGroupId) {
      const denpendentQuestionGroupId = question.denpendentQuestionGroupId;
      const questionsdata = Object.assign([], this.props.questionsData);
      if(includeSerialNumbers){
        const groupQuestions = questionsdata.filter(
          (element: Question) => element.denpendentQuestionGroupId == denpendentQuestionGroupId)
          .sort((a:Question,b:Question)=>{
          return a.questionSequence - b.questionSequence;
        });
        return groupQuestions;
      }else{
        const groupQuestions = questionsdata.filter(
          (element: Question) => element.denpendentQuestionGroupId == denpendentQuestionGroupId 
          && element.serialNumber == question.serialNumber
        ).sort((a:Question,b:Question)=>{
          return a.questionSequence - b.questionSequence;
        });
        return groupQuestions;
      }
     
    }
    return [];
  };

  render() {
    return (
      <>
        <div className="questionaryReviewWrap">
          <QuestionnaireReportForm
            currentQuestions={this.state.currentQuestions}
            formInitialvalues={this.state.formInitialvalues}
            reviewValues={this.state.reviewValues}
            disableFields={this.props.disableFields}
            postsavequestion ={this.postsavequestion}
            formName={this.props.formName}
            clientDetails={this.props.clientDetails}
            showMessageAndHistory={this.props.showMessageAndHistory}
          />
        </div>
      </>
    );
  }
}
export default QuestionnaireReportComponent;
